import { Routes } from '@angular/router';
import { LoginComponent } from './pages/login/pages/login/login.component';

export const AUTH_ROUTES: Routes = [
    {
        path: 'login',
        component: LoginComponent,
    },
];
